export const clicBannerSEO = (dataLayer, { apartado, nombreCampana }) => {
	dataLayer?.push?.({
		'event': 'evento_banner',
		'accion': 'clic_banner',
		'apartado': apartado,
		'elemento': nombreCampana
	})
};

export const clickBreadcrumb = (dataLayer, { origen, destino }) => {
	dataLayer?.push?.({
		'event': 'breadcrumb',
		'accion': 'click_breadcrumb',
		'origen': origen,
		'destino': destino
	})
};

export const clicCard = (dataLayer, { apartado, elemento }) => {
	dataLayer?.push?.({
		'event': 'evento_lista_seo',
		'accion': 'click_card',
		'apartado': apartado,
		'elemento': elemento
	})
};

export const clicFiltroTipoVistaCards = (dataLayer, { apartado, elemento }) => {
	dataLayer?.push?.({
		'event': 'evento_lista_seo',
		'accion': 'click_ver_lista_grilla',
		'apartado': apartado,
		'elemento': elemento
	})
};

export const clicOrdenarPor = (dataLayer, { apartado, elemento }) => {
	dataLayer?.push?.({
		'event': 'evento_lista_seo',
		'accion': 'click_ordenar_por',
		'apartado': apartado,
		'elemento': elemento
	})
};


export const clickPagination = (dataLayer, { apartado, page }) => {

	dataLayer?.push?.({
		'event': 'evento_lista_seo',
		'accion': 'click_paginador',
		'apartado': apartado,
		'elemento': page
	})
};

export const clicTipoBusqueda = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_tipo_busqueda',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicEstadoPropiedad = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_estado_propiedad',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicBannos = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_banos',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicDormitorios = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_dormitorios',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicPrecios = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_precio',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicTipoMoneda = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_tipo_moneda',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicSuperficieUtil = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_superficie_util',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicMultimedia = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_multimedia',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicInmobiliaria = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_inmobiliaria',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicCorredora = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_corredora',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicAnunciante = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_anunciante',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicRegion = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_region',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicComuna = (dataLayer, { apartado, elemento }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_comuna',
			'apartado': apartado,
			'elemento': elemento
		})
};

export const clicLimpiarFiltros = (dataLayer, { apartado }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_limpiar_filtros',
			'apartado': apartado,
		})
};

export const clicCerrarFiltros = (dataLayer, { apartado }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_cerrar_filtros',
			'apartado': apartado,
		})
};

export const clicAplicarFiltro = (dataLayer, { apartado }) => {
	if (apartado !== undefined)
		dataLayer?.push?.({
			'event': 'evento_filtros',
			'accion': 'click_aplicar_filtro',
			'apartado': apartado,
		})
};




